import React, { useEffect, useRef } from 'react';
import { Eye, Heart, Users, MapPin } from 'lucide-react';
import { trackSectionView, trackFeatureUsage } from '../utils/analytics';

const ConceptSection = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            trackSectionView('concept_section');
            trackFeatureUsage('concept_engagement', 'view');
          }
        });
      },
      { threshold: 0.5 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-amber-800 mb-6">
            Le Concept Sun-Spot
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
            Transformer chaque instant d'évasion en découverte authentique
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="text-center group">
            <div className="w-16 h-16 bg-gradient-to-br from-amber-400 to-orange-500 rounded-xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-200">
              <Eye className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-xl font-semibold text-amber-800 mb-4">Découvrir</h3>
            <p className="text-gray-600 leading-relaxed">
              Explorez des lieux uniques et authentiques partagés par la communauté
            </p>
          </div>

          <div className="text-center group">
            <div className="w-16 h-16 bg-gradient-to-br from-amber-400 to-orange-500 rounded-xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-200">
              <Heart className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-xl font-semibold text-amber-800 mb-4">Partager</h3>
            <p className="text-gray-600 leading-relaxed">
              Faites découvrir vos spots secrets et créez du lien avec d'autres passionnés
            </p>
          </div>

          <div className="text-center group">
            <div className="w-16 h-16 bg-gradient-to-br from-amber-400 to-orange-500 rounded-xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-200">
              <Users className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-xl font-semibold text-amber-800 mb-4">Communauté</h3>
            <p className="text-gray-600 leading-relaxed">
              Rejoignez une communauté bienveillante d'amoureux de beaux paysages
            </p>
          </div>

          <div className="text-center group">
            <div className="w-16 h-16 bg-gradient-to-br from-amber-400 to-orange-500 rounded-xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-200">
              <MapPin className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-xl font-semibold text-amber-800 mb-4">Proximité</h3>
            <p className="text-gray-600 leading-relaxed">
              Trouvez des merveilles insoupçonnées dans votre région
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConceptSection;